import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"
import {
  CommenceExecutionMutation,
  CommenceExecutionMutationMutation,
  CommenceExecutionMutationMutationVariables,
  CompleteExecutionMutation,
  CompleteExecutionMutationMutation,
  CompleteExecutionMutationMutationVariables,
  MissionLifecycleState,
} from "@/gql"
import { useAccountContext } from "@/hooks/useAccountContext"


export default /*#__PURE__*/_defineComponent({
  __name: 'MissionStateSwitcher',
  props: {
    state: null,
    missionLifecycleId: null
  },
  setup(__props: any) {

const props = __props as {
  state: string
  missionLifecycleId: string
}

const { isStaff } = useAccountContext()



const canUpdateMissionState = computed(() => {
  return (
    isStaff &&
    (props.state === MissionLifecycleState.ProposalStage ||
      props.state === MissionLifecycleState.ExecutionStage)
  )
})

const { addSuccess, addError } = useNotification()
const { mutate } = useMutation()
const showUpdateMissionDialog = ref(false)
const isSubmitting = ref(false)

const stateToUpdate = computed(() => {
  const map = {
    [MissionLifecycleState.ProposalStage]: MissionLifecycleState.ExecutionStage,
    [MissionLifecycleState.ExecutionStage]: MissionLifecycleState.Completed,
  }
  return map[props.state as keyof typeof map] || props.state
})

const stateInfo = computed(() => {
  const map = {
    [MissionLifecycleState.ExecutionStage]: {
      label: "Move to Execution",
      confirm: "Are you sure you want to move to execution?",
    },
    [MissionLifecycleState.Completed]: {
      label: "Complete Mission",
      confirm: "Are you sure you want to complete this mission?",
    },
  }
  return map[stateToUpdate.value as keyof typeof map] || null
})

const onUpdateMissionState = async () => {
  if (stateToUpdate.value === MissionLifecycleState.ExecutionStage) {
    moveToExecution()
  }
  if (stateToUpdate.value === MissionLifecycleState.Completed) {
    completeMission()
  }
}

const moveToExecution = async () => {
  if (!props.missionLifecycleId) return
  isSubmitting.value = true

  await mutate<CommenceExecutionMutationMutation, CommenceExecutionMutationMutationVariables>({
    mutation: CommenceExecutionMutation,
    variables: {
      missionLifecycleId: props.missionLifecycleId,
    },

    done: () => {
      isSubmitting.value = false
      showUpdateMissionDialog.value = false
    },
    onSuccess: () => {
      addSuccess("Mission moved to execution successfully")
    },
    onMutationError: (error) => {
      addError(error.message)
    },
  })
}

const completeMission = async () => {
  if (!props.missionLifecycleId) return
  isSubmitting.value = true

  await mutate<CompleteExecutionMutationMutation, CompleteExecutionMutationMutationVariables>({
    mutation: CompleteExecutionMutation,
    variables: {
      missionLifecycleId: props.missionLifecycleId,
    },

    done: () => {
      isSubmitting.value = false
      showUpdateMissionDialog.value = false
    },
    onSuccess: () => {
      addSuccess("Mission completed successfully")
    },
    onMutationError: (error) => {
      addError(error.message)
    },
  })
}

return { __sfc: true,isStaff, props, canUpdateMissionState, addSuccess, addError, mutate, showUpdateMissionDialog, isSubmitting, stateToUpdate, stateInfo, onUpdateMissionState, moveToExecution, completeMission }
}

})